import { defineStore } from 'pinia'

export const usePropertyStore = defineStore('property', {
	state: () => ({
		property: {} as any,
		rooms: [] as any[],
		selectedRate: {} as any,
		selectedRoom: {} as any,
		reviewsInfo: {} as any,
		isBookDirectBtn: false,
		soldOutRates: [] as string[],
		currentSoldOutRate: null as string | null,
		// Bumped by the selected room card's own Book button (Book-CTA A/B test, arm B); the booking
		// block watches it and runs the one Book flow, so there is never a second code path to Book.
		bookRequest: 0,
		// Mirrors the booking block's Book-in-flight state so that card button shows the same loading.
		isBookingLoading: false,
		isDateChanged: false,
		promoCode: '' as string,
		bookingMode: null as string | null,
	}),
	getters: {
		getTotalVisitors(state) {
			//return state.criteria.adults + state.criteria.children
		},
	},
	actions: {
		addSoldOutRate(rateRef: string) {
			this.soldOutRates.push(rateRef)
		},
		setCurrentSoldOutRate(rateRef: string) {
			this.currentSoldOutRate = rateRef
		},
		requestBook() {
			this.bookRequest++
		},
		setBookDirectBtnVisible(value: boolean) {
			this.isBookDirectBtn = value
		},
		setProperty(value: any) {
			this.property = value
		},
		setRooms(value: any) {
			this.rooms = value
		},
		setSelectedRate(value: any) {
			this.selectedRate = value
			this.findRoomBySelectedRate()

		},
		setReviewsInfo(value: any) {
			this.reviewsInfo = value
		},
		clearSelectedRate() {
			this.selectedRate = {}
		},
		findRoomBySelectedRate() {
			this.selectedRoom  = this.rooms.find(room => room.rates.find((rate: any) => rate.ref === this.selectedRate.ref))
		},
		clearRooms() {
			this.rooms = []
		},
		setPromoCode(value: string) {
			this.promoCode = value
		},
		setBookingMode(value: string | null) {
			this.bookingMode = value
		}
		/*
		logIn({email, password}: any) {
			return $fetch(`${host}/api/user/v1/auth/sign-in`, {
				method: 'POST',
                body: JSON.stringify({ email, password }),
				parseResponse: JSON.parse,
                headers: {
                  'X-TRIPENING-CONTEXT-ID': this.contextId,
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': '',
                },
				onResponse({ request, response, options }: any) {
					console.log('response', response, response._data)
				}
			})
		}
		 */
	},
})
